import { useIsWhiteboardFeatureEnabled } from '@confluence/whiteboard-utils/entry-points/useIsWhiteboardFeatureEnabled.ts';
import { isContentTypeEnabledInCurrentEnv } from '@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser.ts';

import { ALL_RECENT_ITEMS_COUNT_HOME_REFRESH } from './recentListConstants.ts';
import { useHomeRecentWorkData } from './useHomeRecentWorkData.ts';
import { filteredRecents } from './RecentList.tsx';

export const useIsEligibleForHideRecents = (): boolean | null => {
	const { isNewUser } = useIsNewUser(
		{ activeDaysThreshold: 28 },
		!expValEquals('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment'),
	);
	const { isWhiteboardFeatureEnabled } = useIsWhiteboardFeatureEnabled();
	const isWhiteboardViewedEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
	const isDatabaseEnabled = isContentTypeEnabledInCurrentEnv('database');
	const isSlidesEnabled = isContentTypeEnabledInCurrentEnv('slide');
	const { data, loading } = useHomeRecentWorkData({
		isWhiteboardViewedEnabled,
		isDatabaseEnabled,
		isSlidesEnabled,
		first: ALL_RECENT_ITEMS_COUNT_HOME_REFRESH,
	});

	const recents = filteredRecents(data, false, ALL_RECENT_ITEMS_COUNT_HOME_REFRESH);
	return (
		!loading &&
		!recents.length &&
		isNewUser &&
		expValEquals('cc-hide-pickup-where-you-left-off-exp', 'cohort', 'experiment')
	);
};
